var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EDIT_CHAT_MESSAGE_ROLE, } from '../admin-types/editChat.js';
/**
 * Messages belonging to the in-flight turn: everything after the latest user
 * message. Shared by progress publish (backend) and the Working UI (frontend)
 * so turn scoping cannot drift.
 */
export function messagesAfterLatestUser(messages) {
    for (let i = messages.length - 1; i >= 0; i -= 1) {
        if (messages[i].role === EDIT_CHAT_MESSAGE_ROLE.USER) {
            return messages.slice(i + 1);
        }
    }
    return messages;
}
/**
 * Projects a session onto EditChatAgUiState.workspace: workspace fields plus
 * the latest assistant message for editor apply — not the full chat transcript.
 */
export function toEditChatSessionEventsResponse(session) {
    const { messages } = session, rest = __rest(session, ["messages"]);
    let latestAssistantMessage = null;
    let assistantMessageCount = 0;
    for (const message of messages) {
        if (message.role !== EDIT_CHAT_MESSAGE_ROLE.ASSISTANT ||
            message.failed) {
            continue;
        }
        assistantMessageCount += 1;
        latestAssistantMessage = message;
    }
    return Object.assign(Object.assign({}, rest), { latestAssistantMessage,
        assistantMessageCount });
}
